import { Box } from '@material-ui/core'
import { PrbcReportForm } from 'components/IntegrationReportForms/PrbcReportForm'
import { useAdditionalMaterialStyle } from 'containers/MaterialUiContainer/additionalStyles'
import React from 'react'

export const PrbcReportContainer = () => {
  const additionalStyle = useAdditionalMaterialStyle()
  return (
    <Box className={additionalStyle.wrapper} mb="2rem">
      <PrbcReportForm />
    </Box>
  )
}
